import { useState } from 'react';
import { Box, Grid } from '@mui/material';
import { useSelector } from 'react-redux';
import CreatePayment from './CreatePayment';
import PaymentHistory from './PaymentHistory';
import PaymentSuccess from './Component/PaymentSuccess';
import PaymentFailed from './Component/PaymentFailed';
import PaymentPending from './Component/PaymentPending';
import StickyEntity from '../Common/Entity/StickyEntity';

const Payment = () => {
  const { selectedSupplierData } = useSelector(
      (state) => state.entityReducer
  );
  const isEntityEnabled = selectedSupplierData?.entity_enabled;
  const [paymentRefreshKey, setPaymentRefreshKey] = useState(0);
  const [splashScreen, setSplashScreen] = useState(null);

  const showSplash = (type, refreshAfter = false) => {
    setSplashScreen(type);
    setTimeout(() => {
      setSplashScreen(null);
      if (refreshAfter) setPaymentRefreshKey(k => k + 1);
    }, 3000);
  };

  return (
    <>
      <StickyEntity />
      <Box sx={{ p: 2, mt: {xs : isEntityEnabled ? '96px': 0, md: 0 }, }}>
        <Grid
          container
          spacing={2}
          mb={3}

        >
          <Grid
            item
            xs={12}
            md={6}
          >
            <CreatePayment
              onPaymentSuccess={() => showSplash('success', true)}
              onPaymentFailed={() => showSplash('failed', true)}
              onPaymentPending={() => showSplash('pending', true)}
            />
          </Grid>
            <Grid
            item
            xs={12}
            md={12}

          >
            <PaymentHistory refreshKey={paymentRefreshKey} />
          </Grid>

        </Grid>
      </Box>

      {splashScreen && (
        <Box sx={{ position: 'fixed', inset: 0, zIndex: 1300, bgcolor: 'background.paper' }}>
          {splashScreen === 'success' && <PaymentSuccess />}
          {splashScreen === 'failed'  && <PaymentFailed />}
          {splashScreen === 'pending' && <PaymentPending />}
        </Box>
      )}
    </>
  );
};

export default Payment;
